<template>
  <div class="flex">
    <router-view name="nav" />
    <div class="grow mx-10 mb-10">
      <InfluencerHeader />
      <router-view class="mt-4" />
    </div>
  </div>
</template>
<script>
import router from '../../router'
import InfluencerHeader from '@/components/influencer/InfluencerHeader.vue'

export default {
  components: {
    InfluencerHeader,
  },
  computed: {
    isLogin() {
      return localStorage.getItem('influme_login') !== null
    },
  },
  mounted() {
    if (!this.isLogin) router.push('/home')
  }
}
</script>